import * as actions from './actions';

const initialState = {
	toast: {
		show: false,
		time: null,
		message: null
	},
	credentials: {},
	loading: false,
	error: false,
	errorDetail: null
};

function reduceFetchCredentials(state) {
	return {
		...state,
		loading: true,
		error: false
	};
}

function reduceFetchCredentialsSuccess(state, action) {
	return {
		...state,
		credentials: action.payload,
		loading: false,
		error: false,
		errorDetail: null
	};
}

function reduceFetchCredentialsError(state, action) {
	return {
		...state,
		error: true,
		errorDetail: action.payload,
		loading: false
	};
}

function reduceShowToastNotification(state, action) {
	return {
		...state,
		toast: {
			...state.toast,
			time: action.time,
			message: action.message,
			show: true
		}
	};
}
function reduceHideToastNotification(state) {
	return {
		...state,
		toast: {
			...state.toast,
			time: null,
			message: null,
			show: false
		}
	};
}

export const credentials = (state, action) => {
	state = state || initialState;
	switch (action.type) {
		case actions.FETCH_CREDENTIALS :
			return reduceFetchCredentials(state);
		case actions.FETCH_CREDENTIALS_SUCCESS :
			return reduceFetchCredentialsSuccess(state, action);
		case actions.FETCH_CREDENTIALS_ERROR :
			return reduceFetchCredentialsError(state, action);
		case actions.SHOW_TOAST_NOTIFICATION :
			return reduceShowToastNotification(state, action);
		case actions.HIDE_TOAST_NOTIFICATION :
			return reduceHideToastNotification(state);
		default:
			return state;
	}
};
